export const types = [
    { label: 'All', value: 'all' },
    { label: 'Paid', value: 'paid' },
    { label: 'Received', value: 'received' },
    { label: 'Refund', value: 'refund' },
];
